/**
 * ServiceProgressSection — customer 5-state lattice per category.
 *
 * Each entry from the projection is one row. The customer lattice is:
 *   not_started · looking · in_touch · proposal_ready · booked
 *
 * Renders with simple, calm pills. No urgency colors. No PM-style icons.
 */

import React from 'react';

const LABELS = {
  not_started:    'Not started',
  looking:        'Looking',
  in_touch:       'In touch',
  proposal_ready: 'Proposal ready',
  booked:         'Booked',
};

const TONES = {
  not_started:    'bg-gray-50 text-gray-500 ring-1 ring-gray-200',
  looking:        'bg-blue-50 text-blue-600 ring-1 ring-blue-100',
  in_touch:       'bg-amber-50 text-amber-700 ring-1 ring-amber-100',
  proposal_ready: 'bg-indigo-50 text-indigo-700 ring-1 ring-indigo-100',
  booked:         'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-100',
};

export default function ServiceProgressSection({ items }) {
  if (!items || items.length === 0) return null;
  return (
    <div data-testid="ops-service-progress">
      <p className="text-xs uppercase tracking-wide text-gray-400 mb-2">
        Services
      </p>
      <ul className="space-y-1.5">
        {items.map((entry, idx) => {
          const tone = TONES[entry.state] || TONES.not_started;
          const label = LABELS[entry.state] || 'In progress';
          return (
            <li
              key={`${entry.category || 'cat'}-${idx}`}
              className="flex items-center justify-between gap-3 text-sm"
              data-testid={`ops-service-row-${entry.category || 'unknown'}`}
            >
              <div className="min-w-0 flex-1">
                <p className="text-sm text-gray-800 truncate">
                  {entry.category || 'Service'}
                </p>
                {entry.vendor_name && (
                  <p className="text-xs text-gray-400 truncate">
                    {entry.vendor_name}
                  </p>
                )}
              </div>
              <span
                className={`text-[11px] font-medium px-2 py-0.5 rounded-full shrink-0 ${tone}`}
                data-testid={`ops-service-state-${entry.state}`}
              >
                {label}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
